// ============================================
// Solve Page Entry Point
// ============================================

// Import Bootstrap CSS AND JS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.css';

// Import custom styles
import '../styles/custom.css';

// Import theme toggle
import { initThemeToggle } from './themeToggle.js';

// Import solve page modules
import {
  initChart,
  resetBuildings,
  randomizeBuildings,
  loadPreset,
  setManualHeights,
  addBuilding,
  removeBuilding,
} from './chartSetup.js';

import { getPreset, getPresetOptionsHTML } from './presets.js';
import { showSuccess, showError, showInfo } from './toast.js';

// Initialize theme toggle
initThemeToggle();

console.log('Solve page initializing...');

// Initialize the chart
console.log('Initializing chart...');

try {
  initChart();
  console.log('Chart initialized successfully');
} catch (error) {
  console.error('Error initializing chart:', error);
}

// Populate preset dropdown
const presetSelect = document.getElementById('presetSelect');
if (presetSelect) {
  console.log('Populating preset dropdown...');
  presetSelect.innerHTML = `
    <option value="">-- Choose a Preset --</option>
    ${getPresetOptionsHTML()}
  `;
  console.log('Preset dropdown populated');

  presetSelect.addEventListener('change', (e) => {
    const presetKey = e.target.value;
    if (presetKey) {
      const preset = getPreset(presetKey);
      if (preset) {
        loadPreset(preset.heights);
        showSuccess(`Loaded preset: ${preset.name}`);
        console.log(`Loaded preset: ${preset.name}`, preset.description);
      }
    }
  });
} else {
  console.error('Preset select element not found!');
}

// Reset button
const resetBtn = document.getElementById('resetBtn');
if (resetBtn) {
  resetBtn.addEventListener('click', () => {
    resetBuildings();
    showInfo('Buildings reset to default heights');
    console.log('Buildings reset to default heights');
    
    // Reset preset dropdown
    if (presetSelect) {
      presetSelect.value = '';
    }
  });
  console.log('Reset button wired up');
} else {
  console.error('Reset button not found!');
}

// Randomize button
const randomizeBtn = document.getElementById('randomizeBtn');
if (randomizeBtn) {
  randomizeBtn.addEventListener('click', () => {
    randomizeBuildings();
    showSuccess('Buildings randomized!');
    console.log('Buildings randomized');
  });
  console.log('Randomize button wired up');
} else {
  console.error('Randomize button not found!');
}

// Manual input
const manualInput = document.getElementById('manualHeights');
const applyManualBtn = document.getElementById('applyManualBtn');

if (applyManualBtn && manualInput) {
  applyManualBtn.addEventListener('click', () => {
    const input = manualInput.value.trim();
    if (input) {
      const success = setManualHeights(input);
      if (success) {
        showSuccess('Custom heights applied!');
        manualInput.value = '';
      } else {
        showError('Invalid input. Use comma-separated numbers (10-100).');
      }
    } else {
      showError('Please enter building heights.');
    }
  });

  // Allow Enter key to apply
  manualInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      applyManualBtn.click();
    }
  });
  console.log('Manual input wired up');
}

// Add building button
const addBuildingBtn = document.getElementById('addBuildingBtn');
if (addBuildingBtn) {
  addBuildingBtn.addEventListener('click', () => {
    const success = addBuilding();
    if (success) {
      showSuccess('Building added!');
    } else {
      showError('Maximum 20 buildings reached.');
    }
  });
  console.log('Add building button wired up');
}

// Remove building button
const removeBuildingBtn = document.getElementById('removeBuildingBtn');
if (removeBuildingBtn) {
  removeBuildingBtn.addEventListener('click', () => {
    const success = removeBuilding();
    if (success) {
      showInfo('Building removed.');
    } else {
      showError('Must have at least 1 building.');
    }
  });
  console.log('Remove building button wired up');
}

console.log('? Solve page initialized successfully');
